import { Controller } from "@hotwired/stimulus"
import { populateAndShowModal } from '../helpers/feature_gate_modal'

export default class extends Controller {
  static values = { templateId: String }
  
  connect() {
    console.log("Form builder controller connected")
  }
  
  addField(event) {
    event.preventDefault()
    const fieldType = event.currentTarget.dataset.fieldType
    this.addFieldByType(fieldType)
  }

  addDefaultField(event) {
    event.preventDefault()
    this.addFieldByType('text')
  }
  
  addFieldByType(fieldType) {
    // Send request to add field to the template
    const templateId = this.templateIdValue
    const url = `/event_doc_templates/${templateId}/fields/add_field`
    
    const formData = new FormData()
    formData.append('field[field_type]', fieldType)
    formData.append('authenticity_token', this.getAuthenticityToken())
    
    fetch(url, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (response.ok) {
        // Reload the page to show the new field
        window.location.reload()
      } else {
        console.error('Failed to add field')
      }
    })
    .catch(error => {
      console.error('Error adding field:', error)
    })
  }
  
  addChoice(event) {
    event.preventDefault()
    const fieldId = event.currentTarget.dataset.fieldId
    const templateId = this.templateIdValue
    const url = `/event_doc_templates/${templateId}/fields/${fieldId}/add_choice`
    
    const formData = new FormData()
    formData.append('field_id', fieldId)
    formData.append('authenticity_token', this.getAuthenticityToken())
    
    fetch(url, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (response.ok) {
        window.location.reload()
      } else {
        console.error('Failed to add choice')
      }
    })
    .catch(error => {
      console.error('Error adding choice:', error)
    })
  }

  updateChoice(event) {
    event.preventDefault()
    const fieldId = event.currentTarget.dataset.fieldId
    const choiceIndex = event.currentTarget.dataset.choiceIndex
    const newValue = event.currentTarget.value
    const templateId = this.templateIdValue
    const url = `/event_doc_templates/${templateId}/fields/${fieldId}/update_choice`
    
    const formData = new FormData()
    formData.append('field_id', fieldId)
    formData.append('choice_index', choiceIndex)
    formData.append('choice_text', newValue)
    formData.append('authenticity_token', this.getAuthenticityToken())
    
    fetch(url, {
      method: 'PATCH',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (response.ok) {
        this.showSuccessMessage('Choice updated successfully')
      } else {
        console.error('Failed to update choice')
        this.showErrorMessage('Failed to update choice')
      }
    })
    .catch(error => {
      console.error('Error updating choice:', error)
      this.showErrorMessage('Error updating choice')
    })
  }

  deleteChoice(event) {
    event.preventDefault()
    const fieldId = event.currentTarget.dataset.fieldId
    const choiceIndex = event.currentTarget.dataset.choiceIndex
    const templateId = this.templateIdValue
    const url = `/event_doc_templates/${templateId}/fields/${fieldId}/delete_choice`
    
    const formData = new FormData()
    formData.append('field_id', fieldId)
    formData.append('choice_index', choiceIndex)
    formData.append('authenticity_token', this.getAuthenticityToken())
    
    fetch(url, {
      method: 'DELETE',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (response.ok) {
        window.location.reload()
      } else {
        console.error('Failed to delete choice')
      }
    })
    .catch(error => {
      console.error('Error deleting choice:', error)
    })
  }

  updateFieldLabel(event) {
    event.preventDefault()
    const fieldId = event.currentTarget.dataset.fieldId
    const newLabel = event.currentTarget.value
    const templateId = this.templateIdValue
    const url = `/event_doc_templates/${templateId}/fields/${fieldId}/update_label`
    
    const formData = new FormData()
    formData.append('field_id', fieldId)
    formData.append('label', newLabel)
    formData.append('authenticity_token', this.getAuthenticityToken())
    
    fetch(url, {
      method: 'PATCH',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (response.ok) {
        this.showSuccessMessage('Field label updated successfully')
      } else {
        console.error('Failed to update field label')
        this.showErrorMessage('Failed to update field label')
      }
    })
    .catch(error => {
      console.error('Error updating field label:', error)
      this.showErrorMessage('Error updating field label')
    })
  }

  updateFieldPlaceholder(event) {
    event.preventDefault()
    const fieldId = event.currentTarget.dataset.fieldId
    const newPlaceholder = event.currentTarget.value
    const templateId = this.templateIdValue
    const url = `/event_doc_templates/${templateId}/fields/${fieldId}/update_placeholder`
    
    const formData = new FormData()
    formData.append('field_id', fieldId)
    formData.append('placeholder', newPlaceholder)
    formData.append('authenticity_token', this.getAuthenticityToken())
    
    fetch(url, {
      method: 'PATCH',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (response.ok) {
        this.showSuccessMessage('Field placeholder updated successfully')
      } else {
        console.error('Failed to update field placeholder')
        this.showErrorMessage('Failed to update field placeholder')
      }
    })
    .catch(error => {
      console.error('Error updating field placeholder:', error)
      this.showErrorMessage('Error updating field placeholder')
    })
  }

  updateChoiceWeight(event) {
    event.preventDefault()
    const fieldId = event.currentTarget.dataset.fieldId
    const choiceIndex = event.currentTarget.dataset.choiceIndex
    const newWeight = event.currentTarget.value
    const templateId = this.templateIdValue
    const url = `/event_doc_templates/${templateId}/fields/${fieldId}/update_choice_weight`

    const formData = new FormData()
    formData.append('field_id', fieldId)
    formData.append('choice_index', choiceIndex)
    formData.append('weight', newWeight)
    formData.append('authenticity_token', this.getAuthenticityToken())

    fetch(url, {
      method: 'PATCH',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (response.ok) {
        this.showSuccessMessage(`Choice weight updated to ${newWeight} points`)
      } else {
        console.error('Failed to update choice weight')
        this.showErrorMessage('Failed to update choice weight')
      }
    })
    .catch(error => {
      console.error('Error updating choice weight:', error)
      this.showErrorMessage('Error updating choice weight')
    })
  }

  toggleScoring(event) {
    const fieldId = event.currentTarget.dataset.fieldId
    const isEnabled = event.currentTarget.checked
    const templateId = this.templateIdValue
    const url = `/event_doc_templates/${templateId}/fields/${fieldId}/toggle_scoring`

    console.log(`Toggle scoring for field ${fieldId}: ${isEnabled}`)

    // Toggle visibility of ALL weight-related elements for this field
    const weightContainers = document.querySelectorAll(`[data-weight-container="${fieldId}"]`)
    console.log(`Found ${weightContainers.length} elements with data-weight-container="${fieldId}"`)

    weightContainers.forEach((container, index) => {
      console.log(`Element ${index}:`, container)
      if (isEnabled) {
        container.classList.remove('d-none')
        container.style.display = ''
      } else {
        container.classList.add('d-none')
      }
    })

    // Also look for .choice-points-inline elements within the same field
    const fieldElement = event.currentTarget.closest('.field-preview')
    if (fieldElement) {
      const pointsElements = fieldElement.querySelectorAll('.choice-points-inline')
      console.log(`Found ${pointsElements.length} .choice-points-inline elements in field`)

      pointsElements.forEach((element, index) => {
        console.log(`Points element ${index}:`, element)
        if (isEnabled) {
          element.classList.remove('d-none')
          element.style.display = ''
        } else {
          element.classList.add('d-none')
        }
      })
    }

    // Update toggle label
    const toggleLabel = event.currentTarget.parentElement.querySelector('.toggle-label')
    if (toggleLabel) {
      toggleLabel.textContent = isEnabled ? 'ON' : 'OFF'
    }

    // Immediate visual feedback
    if (isEnabled) {
      this.showSuccessMessage('Scoring enabled - set points for each choice below')
    } else {
      this.showSuccessMessage('Scoring disabled - weight inputs hidden')
    }

    const formData = new FormData()
    formData.append('field_id', fieldId)
    formData.append('enabled', isEnabled)
    formData.append('authenticity_token', this.getAuthenticityToken())

    fetch(url, {
      method: 'PATCH',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (response.ok) {
        console.log('Scoring toggle saved successfully')
      } else {
        console.error('Failed to save scoring toggle')
        this.showErrorMessage('Failed to save scoring setting')
      }
    })
    .catch(error => {
      console.error('Error saving scoring toggle:', error)
      this.showErrorMessage('Error saving scoring setting')
    })
  }

  toggleRequired(event) {
    const fieldId = event.currentTarget.dataset.fieldId
    const isRequired = event.currentTarget.checked
    const templateId = this.templateIdValue
    const url = `/event_doc_templates/${templateId}/fields/${fieldId}/toggle_required`
    
    const formData = new FormData()
    formData.append('field_id', fieldId)
    formData.append('required', isRequired)
    formData.append('authenticity_token', this.getAuthenticityToken())
    
    fetch(url, {
      method: 'PATCH',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (!response.ok) {
        console.error('Failed to toggle field required')
      }
    })
    .catch(error => {
      console.error('Error toggling field required:', error)
    })
  }

  updateFieldType(event) {
    event.preventDefault()
    const fieldId = event.currentTarget.dataset.fieldId
    const newFieldType = event.currentTarget.value
    const templateId = this.templateIdValue
    const url = `/event_doc_templates/${templateId}/fields/${fieldId}/update_field_type`

    const formData = new FormData()
    formData.append('field_id', fieldId)
    formData.append('field_type', newFieldType)
    formData.append('authenticity_token', this.getAuthenticityToken())

    fetch(url, {
      method: 'PATCH',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (response.ok) {
        window.location.reload()
      } else if (response.status === 403) {
        response.json().then(data => {
          if (data.upgrade_required) {
            this.openFeatureGateModal(data)
          } else {
            this.showErrorMessage(data.message || 'This feature requires an upgraded plan.')
          }
        })
      } else {
        console.error('Failed to update field type')
        this.showErrorMessage('Failed to update field type')
      }
    })
    .catch(error => {
      console.error('Error updating field type:', error)
      this.showErrorMessage('Error updating field type')
    })
  }

  duplicateField(event) {
    event.preventDefault()
    const fieldId = event.currentTarget.dataset.fieldId
    const templateId = this.templateIdValue
    const url = `/event_doc_templates/${templateId}/fields/${fieldId}/duplicate`

    const formData = new FormData()
    formData.append('field_id', fieldId)
    formData.append('authenticity_token', this.getAuthenticityToken())

    fetch(url, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (response.ok) {
        window.location.reload()
      } else {
        console.error('Failed to duplicate field')
        this.showErrorMessage('Failed to duplicate field')
      }
    })
    .catch(error => {
      console.error('Error duplicating field:', error)
      this.showErrorMessage('Error duplicating field')
    })
  }

  deleteField(event) {
    event.preventDefault()
    const fieldId = event.currentTarget.dataset.fieldId
    if (confirm('Are you sure you want to delete this field?')) {
      const templateId = this.templateIdValue
      const url = `/event_doc_templates/${templateId}/fields/${fieldId}`

      const formData = new FormData()
      formData.append('field_id', fieldId)
      formData.append('authenticity_token', this.getAuthenticityToken())

      fetch(url, {
        method: 'DELETE',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => {
        if (response.ok) {
          window.location.reload()
        } else {
          console.error('Failed to delete field')
        }
      })
      .catch(error => {
        console.error('Error deleting field:', error)
      })
    }
  }

  uploadPdf(event) {
    event.preventDefault()
    const fieldId = event.currentTarget.dataset.fieldId
    const file = event.currentTarget.files[0]

    if (!file) return

    // Validate file type
    if (file.type !== 'application/pdf') {
      this.showErrorMessage('Please select a PDF file')
      event.currentTarget.value = ''
      return
    }

    // Validate file size (10MB limit)
    const maxSize = 10 * 1024 * 1024 // 10MB in bytes
    if (file.size > maxSize) {
      this.showErrorMessage('PDF file must be smaller than 10MB')
      event.currentTarget.value = ''
      return
    }

    const templateId = this.templateIdValue
    const url = `/event_doc_templates/${templateId}/fields/${fieldId}/upload_pdf`

    const formData = new FormData()
    formData.append('field_id', fieldId)
    formData.append('pdf_document', file)
    formData.append('authenticity_token', this.getAuthenticityToken())

    // Show loading state
    const uploadArea = event.currentTarget.closest('.pdf-upload-area')
    const originalContent = uploadArea.innerHTML
    uploadArea.innerHTML = '<div class="text-center"><i class="fas fa-spinner fa-spin me-2"></i>Uploading PDF...</div>'

    fetch(url, {
      method: 'PATCH',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (response.ok) {
        this.showSuccessMessage('PDF uploaded successfully')
        window.location.reload()
      } else {
        console.error('Failed to upload PDF')
        this.showErrorMessage('Failed to upload PDF')
        uploadArea.innerHTML = originalContent
      }
    })
    .catch(error => {
      console.error('Error uploading PDF:', error)
      this.showErrorMessage('Error uploading PDF')
      uploadArea.innerHTML = originalContent
    })
  }

  removePdf(event) {
    event.preventDefault()
    const fieldId = event.currentTarget.dataset.fieldId

    if (confirm('Are you sure you want to remove this PDF document?')) {
      const templateId = this.templateIdValue
      const url = `/event_doc_templates/${templateId}/fields/${fieldId}/remove_pdf`

      const formData = new FormData()
      formData.append('field_id', fieldId)
      formData.append('authenticity_token', this.getAuthenticityToken())

      fetch(url, {
        method: 'DELETE',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => {
        if (response.ok) {
          this.showSuccessMessage('PDF removed successfully')
          window.location.reload()
        } else {
          console.error('Failed to remove PDF')
          this.showErrorMessage('Failed to remove PDF')
        }
      })
      .catch(error => {
        console.error('Error removing PDF:', error)
        this.showErrorMessage('Error removing PDF')
      })
    }
  }

  updateRichContent(event) {
    event.preventDefault()
    const fieldId = event.currentTarget.dataset.fieldId
    const content = event.currentTarget.value
    const templateId = this.templateIdValue
    const url = `/event_doc_templates/${templateId}/fields/${fieldId}/update_rich_content`

    const formData = new FormData()
    formData.append('field_id', fieldId)
    formData.append('content', content)
    formData.append('authenticity_token', this.getAuthenticityToken())

    fetch(url, {
      method: 'PATCH',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (response.ok) {
        this.showSuccessMessage('Rich content updated successfully')
      } else {
        console.error('Failed to update rich content')
        this.showErrorMessage('Failed to update rich content')
      }
    })
    .catch(error => {
      console.error('Error updating rich content:', error)
      this.showErrorMessage('Error updating rich content')
    })
  }

  toggleAgreementCheckbox(event) {
    const fieldId = event.currentTarget.dataset.fieldId
    const showAgreement = event.currentTarget.checked
    const templateId = this.templateIdValue
    const url = `/event_doc_templates/${templateId}/fields/${fieldId}/toggle_agreement_checkbox`

    const formData = new FormData()
    formData.append('field_id', fieldId)
    formData.append('show_agreement_checkbox', showAgreement)
    formData.append('authenticity_token', this.getAuthenticityToken())

    fetch(url, {
      method: 'PATCH',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (response.ok) {
        this.showSuccessMessage('Agreement checkbox setting updated')
        // Update the visual indicator
        const toolbar = event.currentTarget.closest('.rich-textarea-preview').querySelector('.rich-textarea-preview-toolbar')
        const indicator = toolbar.querySelector('.text-success')
        if (showAgreement && !indicator) {
          const newIndicator = document.createElement('small')
          newIndicator.className = 'text-success ms-2'
          newIndicator.innerHTML = '<i class="fas fa-check-circle me-1"></i>Agreement checkbox enabled'
          toolbar.appendChild(newIndicator)
        } else if (!showAgreement && indicator) {
          indicator.remove()
        }
      } else {
        console.error('Failed to toggle agreement checkbox')
        this.showErrorMessage('Failed to update agreement checkbox setting')
      }
    })
    .catch(error => {
      console.error('Error toggling agreement checkbox:', error)
      this.showErrorMessage('Error updating agreement checkbox setting')
    })
  }

  openFeatureGateModal(data) {
    populateAndShowModal({
      tierLabel: data.tier_label,
      title: data.title,
      description: data.message,
      tier: data.tier,
      upgradeUrl: data.upgrade_url,
      price: data.price
    })
  }

  showSuccessMessage(message) {
    this.showMessage(message, 'success')
  }

  showErrorMessage(message) {
    this.showMessage(message, 'error')
  }

  showMessage(message, type) {
    // Remove any existing messages
    const existingMessages = document.querySelectorAll('.form-builder-message')
    existingMessages.forEach(msg => msg.remove())

    // Create new message element
    const messageElement = document.createElement('div')
    messageElement.className = `form-builder-message alert alert-${type === 'success' ? 'success' : 'danger'} alert-dismissible fade show`
    messageElement.style.cssText = 'position: fixed; top: 20px; right: 20px; z-index: 9999; min-width: 300px;'
    
    messageElement.innerHTML = `
      ${message}
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    `
    
    document.body.appendChild(messageElement)
    
    // Auto-remove after 3 seconds
    setTimeout(() => {
      if (messageElement && messageElement.parentNode) {
        messageElement.remove()
      }
    }, 3000)
  }

  getAuthenticityToken() {
    const tokenElement = document.querySelector('meta[name="csrf-token"]')
    return tokenElement ? tokenElement.content : ''
  }
}